import React from 'react';
import { AlertTriangle, ExternalLink, X } from 'lucide-react';
import { cn } from '../../lib/utils';
import type { OpenOrderInfo } from '../../lib/open-order-check';
interface OpenOrderAlertProps {
  order: OpenOrderInfo;
  onDismiss: () => void;
  onViewTracking?: () => void;
}
/**
 * Modal alert shown when a customer with an open order tries to add items to cart.
 * Matches the app's light theme (customer-facing pages).
 */
export function OpenOrderAlert({
  order,
  onDismiss,
  onViewTracking
}: OpenOrderAlertProps) {
  const shortNumber = order.order_number?.split('-').pop() || order.order_number;
  return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" onClick={onDismiss} data-id="element-2924" data-mp="2f210qbyta5ju">
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" data-id="element-2925" data-mp="2b1yurqm1mpyr" />

      <div className="relative bg-white rounded-2xl shadow-2xl max-w-sm w-full overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-2926" data-mp="ko9k2si2elew">
        {/* Close button */}
        <button onClick={onDismiss} className="absolute top-3 right-3 w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors z-10" data-id="element-2927" data-mp="1jj9eykqedbko">
          <X className="w-4 h-4 text-gray-500" data-id="element-2928" data-mp="1tgnixkv4w7w3" />
        </button>

        {/* Icon + Title */}
        <div className="px-6 pt-6 pb-3 text-center" data-id="element-2929" data-mp="1y7x86kcrt97g">
          <div className="w-14 h-14 rounded-full bg-amber-100 flex items-center justify-center mx-auto mb-4" data-id="element-2930" data-mp="1y9qhy8iok9jo">
            <AlertTriangle className="w-7 h-7 text-amber-600" data-id="element-2931" data-mp="23935ywlafmnu" />
          </div>
          <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-2932" data-mp="276ir4gm5mq8r">
            Pedido abierto
          </h3>
          <p className="text-sm text-gray-600 leading-relaxed" data-id="element-2933" data-mp="2c5c0bwuerv34">
            Tienes un pedido abierto{' '}
            <span className="font-bold text-gray-900" data-id="element-2934" data-mp="2h45g5vx63y6g">#{shortNumber}</span>.
            ¿Deseas realizar un pedido nuevo?
          </p>
        </div>

        {/* Tracking link */}
        {order.tracking_link && <div className="px-6 pb-3 text-center" data-id="element-2935" data-mp="erj2zoyrdsde">
            <a href={order.tracking_link} target="_blank" rel="noreferrer" onClick={e => {
          e.stopPropagation();
          onViewTracking?.();
        }} className="inline-flex items-center gap-1.5 text-sm font-medium text-blue-600 hover:text-blue-700 hover:underline" data-id="element-2936" data-mp="esayz0w9ps47">
              <ExternalLink className="w-4 h-4" data-id="element-2937" data-mp="xplnbqgd314v" />
              Ver seguimiento del pedido anterior
            </a>
          </div>}

        {/* Actions */}
        <div className="px-6 pb-6 pt-2 flex flex-col gap-2" data-id="element-2938" data-mp="17gghri3rh71e">
          <button onClick={onDismiss} className="w-full h-11 rounded-xl bg-gray-900 hover:bg-gray-800 text-white text-sm font-bold transition-colors active:scale-[0.98]" data-id="element-2939" data-mp="17fonqbptbhd8">
            Sí, realizar pedido nuevo
          </button>

          <div className="flex gap-2" data-id="element-2940" data-mp="1cgcfizlv828i">
            {order.tracking_link && <a href={order.tracking_link} target="_blank" rel="noreferrer" className="flex-1 h-11 rounded-xl border border-gray-200 bg-white hover:bg-gray-50 text-gray-700 text-sm font-medium transition-colors flex items-center justify-center gap-1.5" data-id="element-2941" data-mp="1w1mfn1za713v">
                <ExternalLink className="w-4 h-4" data-id="element-2942" data-mp="1r0ylw8jo465y" />
                Ver seguimiento
              </a>}
            <button onClick={onDismiss} className="flex-1 h-11 rounded-xl border border-gray-200 bg-white hover:bg-gray-50 text-gray-700 text-sm font-medium transition-colors" data-id="element-2943" data-mp="1cbsnunwkglzn">
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>;
}